import { render, staticRenderFns } from "./GetPuzzleForm.vue?vue&type=template&id=2c19b9ca"
import script from "./GetPuzzleForm.vue?vue&type=script&lang=ts"
export * from "./GetPuzzleForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports